import SidebarContent from "./SidebarContent";
import Background from "../../assets/icons/pback.png";

const DesktopSidebar = () => (
  <aside className="z-50 relative flex-shrink-0 hidden w-72 overflow-y-auto bg-white md:block">
    <SidebarContent />
    <div
      className="absolute w-full h-full top-0 right-0 bg-repeat-y opacity-10 -z-10"
      style={{ backgroundImage: `url(${Background})`, filter: 'brightness(170%)' }}
    />
  </aside>
);

export default DesktopSidebar;
